var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 11C6.27411 11.9122 5.99752 12.9467 5.998 13.9996C5.99849 15.0525 6.27604 16.0867 6.80277 16.9984C7.32951 17.9101 8.08688 18.6671 8.9988 19.1934C9.91073 19.7197 10.9451 19.9968 11.998 19.9968C13.0509 19.9968 14.0853 19.7197 14.9972 19.1934C15.9091 18.6671 16.6665 17.9101 17.1932 16.9984C17.72 16.0867 17.9975 15.0525 17.998 13.9996C17.9985 12.9467 17.7219 11.9122 17.196 11L11.999 3L6.799 11H6.8Z",
    stroke: "#2D12D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryIcon);
export default __webpack_public_path__ + "static/media/category-icon.2d99cd4b36c067e4710123bd7886fbf0.svg";
export { ForwardRef as ReactComponent };